export default {
  CompanySettings: {
    AllocateCategories: '',
    IsRequiredCategRefID: '',
    AllocateVAT: '',
    DaysNo: 0,
    DisplayBudgetStep: '',
    OverrideSupplierPaymentTerms: '',
    RequireAttachment: '',
    HasCostCenter: '',
    HasBusinessUnit: '',
    UseBusinessUnitAndCostCenterMapping: ''
  }
}



// WEBPACK FOOTER //
// ./src/components/_modules/I2P/models/settings-model.js